import { Button, Grid, Typography } from "@mui/material";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import saveAs from "file-saver";
import moment from "moment";
import * as React from "react";

export default function ResultadoDatosDispersion(props) {
  const { data } = props;
  const { lineacaptura } = props;
  const { totales } = props;
  const { handleBack } = props;

  const crearArchivo = () => {
    let dato = "";
    const crlf = "\r\n";
    for (let i = 0; i < lineacaptura.length; i++) {
      dato += lineacaptura[i].empleado + crlf;
    }
    const blob = new Blob([dato], { type: "text/plain;charset=utf-8" });
    saveAs(
      blob,
      "ArchivoDispersion-" +
        data[0].departamento +
        "-" +
        moment().format("DD-MM-YYYY-HHmmss")
    );
  };

  return (
    <>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell>DEPARTAMENTO</TableCell>
              <TableCell align="center">CODIGO EMPPLEADO</TableCell>
              <TableCell align="center">NO. CUENTA</TableCell>
              <TableCell align="left">NOMBRE</TableCell>
              <TableCell align="center">SEMANA</TableCell>
              <TableCell align="center">NETO</TableCell>
              <TableCell align="center">SEMANA 2</TableCell>
              <TableCell align="center">NETO</TableCell>
              <TableCell align="center">TOTAL</TableCell>
              <TableCell align="center">EJERCICIO</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, Index) => (
              <TableRow
                key={Index}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {row.departamento}
                </TableCell>
                <TableCell align="center">{row.codigoempleado}</TableCell>
                <TableCell align="center">
                  {row.cuentapagoelectronico}
                </TableCell>
                <TableCell align="left">{row.nombrelargo}</TableCell>
                <TableCell align="center">{row.semana1}</TableCell>
                <TableCell align="center">{row.neto1}</TableCell>
                <TableCell align="center">{row.semana2}</TableCell>
                <TableCell align="center">{row.neto2}</TableCell>
                <TableCell align="center">{row.total}</TableCell>
                <TableCell align="center">{row.ejercicio}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <br />
      <Grid container>
        <Grid item md={10}>
          <Typography variant="h5">Total empleados: {data.length}</Typography>
        </Grid>
        <Grid item md={2}>
          <Typography textAlign="right" variant="h5" color="secondary">
            <b>Neto 1:</b> {totales.netoperiodo1 ? totales.netoperiodo1 : 0}{" "}
          </Typography>
        </Grid>
        <Grid item md={12}>
          <Typography textAlign="right" variant="h5" color="secondary">
            <b>Neto 2:</b> {totales.netoperiodo2 ? totales.netoperiodo2 : 0}
          </Typography>
        </Grid>
        <Grid item md={12}>
          <Typography textAlign="right" variant="h5" color="secondary">
            <b>Total:</b> <u>{totales.total ? totales.total : 0}</u>
          </Typography>
        </Grid>
      </Grid>

      <Grid container spacing={3} justifyContent="center" direction="row">
        <Grid item>
          <Button onClick={crearArchivo} variant="contained" color="success">
            Descargar archivo
          </Button>
        </Grid>

        <Grid item>
          <Button
            variant="contained"
            color="success"
            onClick={(e) => handleBack(3)}
          >
            {" "}
            Atras
          </Button>
        </Grid>
      </Grid>
    </>
  );
}
